import ApiKeyTextField from "components/ApiKeyTextField";
import Button from "components/Button";
import Card from "components/Card";
import { Tooltip } from "components/Tooltip";

import Messages from "misc/Messages";

import { useUser } from "routes/dataroutes/UserData";


export default function ApiKeyCard(
  {
    className,
  }: {
    className?: string;
  }
) {
  const user = useUser();

  return (
    <Card
      className={ className }
      title={ <Tooltip content={ Messages.apiKeyCardTooltipMessage } className="self-start">API key</Tooltip> }
      extra={
        user?.isBlocked ? undefined :
          <Button
            text="Manage"
            size="SM"
            className="button button-text-primary text-xs"
            href="api-keys"
            useViewTransitions
          />
      }
    >
      <ApiKeyTextField />
    </Card>
  );
};
